module.exports = __webpack_public_path__ + "static/media/FeedHive_ai.d582983a.png";